import { useCallback, useContext, useEffect, useMemo } from 'react'
import { formats, messages, translations } from './calendar-utils'
import { ScheduleEditor } from '../create-schedule'
import { GlobalContext } from '../../../../../App'
import { metodoPrograma } from '../../../../../components/api'
import { AgendaContext } from '../..'
import { Calendar, dayjsLocalizer } from 'react-big-calendar'
import 'react-big-calendar/lib/css/react-big-calendar.css'
import withDragAndDrop from 'react-big-calendar/lib/addons/dragAndDrop'
import 'react-big-calendar/lib/addons/dragAndDrop/styles.css'
import './calendarOverrides.css'
import dayjs from 'dayjs'
import { EventRender } from './EventRender'

const localizer = dayjsLocalizer(dayjs)

const DragAndDropCalendar = withDragAndDrop(Calendar)

const ResourceHeader = ({ resource }) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        padding: '8px',
        height: '80px',
        backgroundColor: '#f6f6f6',
      }}
    >
      <strong
        style={{
          fontWeight: 500,
          whiteSpace: 'normal',
          lineHeight: '1.5',
          wordBreak: 'break-word',
          fontSize: 13,
        }}
      >
        {resource.name}
      </strong>
    </div>
  )
}

export const ConsultsList = ({ listaAgendamentos }) => {
  const { terapias, consults, dispatch, agendamentoSelecionado } =
    useContext(AgendaContext)
  const { agenda } = useContext(GlobalContext)

  const events = useMemo(
    () =>
      consults?.map((item) => ({
        id: item[0],
        title: item[3],
        start: new Date(item[1]),
        end: new Date(item[2]),
        data: item,
        resourceId: item[16],
      })),
    [consults],
  )
  const nrTempoAgenda = 60

  const buscaDadosMedico = useCallback(
    (cdMedico) => {
      metodoPrograma('buscaDadosMedico', { cdMedico }).then((res) => {
        if (res.status) {
          dispatch({ field: 'medico', value: res })
        }
      })
    },
    [dispatch],
  )

  const onSelectEvent = (event) => {
    dispatch({
      field: 'agendamentoSelecionado',
      value: {
        data: event.data,
        modal: true,
        start: event.start,
        end: event.end,
        resourceId: event.resourceId,
      },
    })
  }

  const onSlotSelect = (slot) => {
    dispatch({
      field: 'agendamentoSelecionado',
      value: {
        start: slot.start,
        end: slot.end,
        modal: true,
        resourceId: slot.resourceId,
      },
    })
  }

  const onNavigate = (date) => {
    dispatch({ field: 'selectedDay', value: date })
  }

  useEffect(() => {
    if (agenda !== null) {
      buscaDadosMedico(agenda[2])
    }
    if (agendamentoSelecionado.modal === false) {
      dispatch({
        field: 'agendamentoSelecionado',
        value: { data: null, modal: false },
      })
    }
  }, [agenda, buscaDadosMedico, dispatch, agendamentoSelecionado.modal])

  const onEventDrop = async ({ event, start, end, resourceId }) => {
    const obj = {
      idAgendamento: event.id,
      idAgenda: resourceId,
      dtInicio: dayjs(start).format('YYYY-MM-DD HH:mm'),
      dtFim: dayjs(end).format('YYYY-MM-DD HH:mm'),
    }
    dispatch({
      type: 'setConsults',
      value: consults.map((value) => {
        const item = [...value]
        if (item[0] === event.id) {
          item[1] = start
          item[2] = end
          item[16] = resourceId
        }
        return item
      }),
    })
    await metodoPrograma('trocaPosicaoAgendamento', obj).then((res) => {
      if (res.status) {
        listaAgendamentos()
      }
    })
  }

  return (
    <>
      <DragAndDropCalendar
        localizer={localizer}
        messages={messages}
        formats={formats}
        translations={translations}
        onSelectEvent={onSelectEvent}
        selectable
        onEventDrop={onEventDrop}
        onSelectSlot={onSlotSelect}
        components={{
          event: ({ event }) => <EventRender event={event} />,
          resourceHeader: ResourceHeader,
        }}
        views={['day']}
        eventPropGetter={() => ({
          style: {
            backgroundColor: 'transparent',
            cursor: 'pointer',
            border: 'none',
            color: 'transparent',
            fontSize: '4px',
          },
        })}
        slotPropGetter={() => ({
          style: {
            backgroundColor: 'white',
            width: '100%',
            minHeight: '120px',
            cursor: 'pointer',
            fontSize: '13px',
          },
        })}
        onNavigate={onNavigate}
        min={dayjs().hour(7).minute(0)}
        max={dayjs().hour(19).minute(0)}
        step={nrTempoAgenda}
        timeslots={1}
        startAccessor="start"
        endAccessor="end"
        defaultView="day"
        resources={terapias || []}
        resourceIdAccessor="id"
        resourceTitleAccessor="name"
        events={events}
        hourFormat="24"
        style={{ height: 'calc(100vh - 50px)', marginTop: '20px' }}
      />
      {agendamentoSelecionado.modal && (
        <ScheduleEditor listaAgendamentos={listaAgendamentos} />
      )}
    </>
  )
}
